import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Paths } from "./Paths";
import HomePage from "../pages/HomePage";
import WelcomePage from "../pages/WelcomePage";
import ReagistrationPage from "../pages/ReagistrationPage";
import PaymentAndtTaxPage from "../pages/PaymentAndtTaxPage";
import TwoStepVerificationPage from "../pages/TwoStepVerificationPage";
import AiFilterPage from "../pages/AiFilterPage";
import Mainnav from "../components/Mainnav";
import TourManagementCreatePage from "../pages/TourManagementCreatePage";
import TourManagementPackageNamePage from "../pages/TourManagementPackageNamePage";
import TourManagementPackageDescriptionPage from "../pages/TourManagementPackageDescriptionPage";
import TourManagementPackageLocationPage from "../pages/TourManagementPackageLocationPage";
import TourManagementPackageKeywordsPage from "../pages/TourManagementPackageKeywordsPage";
import TourManagementPackageGuideInfoPage from "../pages/TourManagementGuideInfoPage";
import TourManagementPackageFoodPage from "../pages/TourManagementPackageFoodPage";
import TourManagementPackageTransportationPage from "../pages/TourManagementPackageTransportationPage";
import TourManagementPackageExtraInfoPage from "../pages/TourManagementPackageExtraInfoPage";
import TourManagementPackagePhotoUploadPage from "../pages/TourManagementPackagePhotoUploadPage";
import TourManagementPackageOptionsPage from "../pages/TourManagementPackageOptionsPage";
import TourManagementPackageOptionsSetupPage from "../pages/TourManagementPackageOptionsSetupPage";
import TourManagementPackageMeetingPage from "../pages/TourManagementPackageMeetingPage";
import TourManagementPackageConnectivityPage from "../pages/TourManagementPackageConnectivityPage";
import TourManagementPackageAvailabilityPage from "../pages/TourManagementPackageAvailabilityPage";
import TourManagementPackageAvailabilitySchedulePage from "../pages/TourManagementAvailabilitySchedulePage";
import TourManagementPackageAvailabilityPriceCategoryPage from "../pages/TourManagementPackageAvailabilityPriceCategoryPage";
import TourManagementPackageAvailabilityCapacityPage from "../pages/TourManagementPackageAvailabilityCapacityPage";
import TourManagementPackageAvailabilityPricePage from "../pages/TourManagementPackageAvailabilityPricePage";
import TourManagementPackageAvailabilityAddOnPage from "../pages/TourManagementPackageAvailabilityAddOnPage";
import LoginPage from "../pages/LoginPage";
import SignUpPage from "../pages/SignUpPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import VerifyEmailPage from "../pages/VerifyEmailPage";
import RecoverPasswordPage from "../pages/RecoverPasswordPage";
import useLoadCache from "../hooks/useLoadCache";
import Redirect from "./Redirect";
import ManagePage from "../pages/ManagePage";
import BookingPage from "../pages/BookingPage";
import UserTypePage from "../pages/UserTypePage";
import AuthCallback from "../sections/authentication/AuthCallback";
import CancelationPolicy from "../pages/TourManagementCancelationPolicy";
import AvailabilityPage from "../pages/ManagePage";
import TourManagementInclusionPage from "../pages/TourManagementInclusionPage";
import TourManagementCutOffPage from "../pages/TourManagementCutOffPage";
import CreateSpecialOfferPage from "../pages/CreateSpecialOfferPage";
import ManageSpecialOffersPage from "../pages/ManageSpecialOfferPage";
import ProductPage from "../pages/ManageProductPage";
import ProtocolPage from "../pages/CreateProtocolPage";
import CreateProtocolPage from "../pages/CreateProtocolPage";
import FinancePage from "../pages/FinancePage";
import PrivacyPolicyPage from "../pages/info/PrivacyPolicyPage";
import ProductDetailPage from "../pages/manage/ProductDetailPage";
import ProductOptionsDetailPage from "../pages/manage/ProductOptionsDetailPage";

function AppRouter() {
  useLoadCache();
  return (
    <Router>
      <Mainnav />
      <Redirect />
      <Routes>
        <Route path={Paths.home} Component={HomePage} />
        <Route path={Paths.login} Component={LoginPage} />
        <Route path={Paths.signup} Component={SignUpPage} />
        <Route path={Paths.callback} Component={AuthCallback} />
        <Route path={Paths.forgot} Component={ForgotPasswordPage} />
        <Route path={Paths.verifyEmail} Component={VerifyEmailPage} />
        <Route path={Paths.userType} Component={UserTypePage} />
        <Route path={Paths.recoverPassword} Component={RecoverPasswordPage} />
        <Route path={Paths.welcome} Component={WelcomePage} />
        <Route path={Paths.registration} Component={ReagistrationPage} />
        <Route path={Paths.paymentAndTax} Component={PaymentAndtTaxPage} />
        <Route path={Paths.verification} Component={TwoStepVerificationPage} />

        <Route path={Paths.aifilter} Component={AiFilterPage} />

        <Route
          path={Paths.tourManagementCreate}
          Component={TourManagementCreatePage}
        />
        <Route
          path={Paths.tourManagementPackageName}
          Component={TourManagementPackageNamePage}
        />
        <Route
          path={Paths.tourManagementPackageDescription}
          Component={TourManagementPackageDescriptionPage}
        />
        <Route
          path={Paths.tourManagementPackageLocation}
          Component={TourManagementPackageLocationPage}
        />
        <Route
          path={Paths.tourManagementPackageKeywords}
          Component={TourManagementPackageKeywordsPage}
        />
        <Route
          path={Paths.tourManagementPackageInclusion}
          Component={TourManagementInclusionPage}
        />
        <Route
          path={Paths.tourManagementPackageGuideInfo}
          Component={TourManagementPackageGuideInfoPage}
        />
        <Route
          path={Paths.tourManagementPackageFood}
          Component={TourManagementPackageFoodPage}
        />
        <Route
          path={Paths.tourManagementPackageTransportation}
          Component={TourManagementPackageTransportationPage}
        />
        <Route
          path={Paths.tourManagementPackageExtraInfo}
          Component={TourManagementPackageExtraInfoPage}
        />
        <Route
          path={Paths.tourManagementPackagePhotoUpload}
          Component={TourManagementPackagePhotoUploadPage}
        />
        <Route
          path={Paths.tourManagementPackageOptions}
          Component={TourManagementPackageOptionsPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsSetup}
          Component={TourManagementPackageOptionsSetupPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsMeeting}
          Component={TourManagementPackageMeetingPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsConnectivity}
          Component={TourManagementPackageConnectivityPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsAvailability}
          Component={TourManagementPackageAvailabilityPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsAvailabilitySchedule}
          Component={TourManagementPackageAvailabilitySchedulePage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsAvailabilityPriceCategory}
          Component={TourManagementPackageAvailabilityPriceCategoryPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsAvailabilityCapacity}
          Component={TourManagementPackageAvailabilityCapacityPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsAvailabilityPrice}
          Component={TourManagementPackageAvailabilityPricePage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsCutOff}
          Component={TourManagementCutOffPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsAvailabilityAddOn}
          Component={TourManagementPackageAvailabilityAddOnPage}
        />
        <Route
          path={Paths.tourManagementPackageOptionsCancelationPolicy}
          Component={CancelationPolicy}
        />
        <Route path={Paths.availablity} Component={AvailabilityPage} />
        <Route path={Paths.booking} Component={BookingPage} />
        <Route path={Paths.specialOffers} Component={CreateSpecialOfferPage} />
        <Route
          path={Paths.manageSpecialOffers}
          Component={ManageSpecialOffersPage}
        />
        <Route path={Paths.manageProduct} Component={ProductPage} />
        <Route path={Paths.createProtocol} Component={CreateProtocolPage} />
        <Route path={Paths.finance} Component={FinancePage} />
        <Route path={Paths.privacyPolicy} Component={PrivacyPolicyPage} />
        <Route
          path={Paths.manageProductDetails}
          Component={ProductDetailPage}
        />
        <Route
          path={Paths.manageProductOptionsDetails}
          Component={ProductOptionsDetailPage}
        />
      </Routes>
    </Router>
  );
}

export default AppRouter;
